import store from '@/store';
import { CONSTANTS } from '@/config/constants';

import AuthService from './AuthService';
import ApiService from './ApiService';

let sequentialRequestId = 0;
let webSocket: any;
const eventsMap: {
  [requestId: string]: {
    [operation: string]: string,
  },
} = {};

async function createWebSocket() {
  const result = await ApiService.post('/parse/functions/liveQueryServerURL', undefined, false);

  webSocket = new WebSocket(result.result);

  webSocket.onopen = () => {
    const connectData = { op: 'connect', applicationId: CONSTANTS.applicationId };
    webSocket.send(JSON.stringify(connectData));
    console.log('websocket initiated');
  };

  webSocket.onmessage = (msg: any) => {
    const obj: any = JSON.parse(msg.data);
    const operationsMap: any = eventsMap[obj.requestId];
    if (obj.op === 'connected') {
      store.commit('setConnected', true);
    } else {
      if (operationsMap) {
        const dispatchName = operationsMap[obj.op];
        if (dispatchName) {
          store.commit(dispatchName, obj.object);
        }
      }
    }
  };
}

async function subscribe(payload: { query: {
  where: any, className: string,
}, events: { [eventName: string]: string } }) {
  const sessionToken = await AuthService.getSessionToken();
  sequentialRequestId += 1;
  const data = {
    op: 'subscribe',
    requestId: sequentialRequestId,
    query: payload.query,
    sessionToken,
  };
  eventsMap[sequentialRequestId] = payload.events;
  return new Promise((resolve) => {
    if (store.state.socket.connected) {
      webSocket.send(JSON.stringify(data));
      resolve(sequentialRequestId);
    } else {
      store.watch((state) => state.socket.connected, (newValue) => {
        if (newValue) {
          webSocket.send(JSON.stringify(data));
          resolve(sequentialRequestId);
        }
      });
    }
  });
}

function unsubscribe(requestId: number) {
  const data = {
    op: 'unsubscribe',
    requestId,
  };
  webSocket.send(JSON.stringify(data));
}

const SocketService = {
  createWebSocket,
  webSocket,
  subscribe,
  unsubscribe,
};

export default SocketService;
